import { render } from "./DescontoList.vue?vue&type=template&id=063bd17d&scoped=true"
import script from "./DescontoList.vue?vue&type=script&lang=js"
export * from "./DescontoList.vue?vue&type=script&lang=js"

import "./DescontoList.vue?vue&type=style&index=0&id=063bd17d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063bd17d"]])

export default __exports__